import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

type ContainerProps = {
  isError?: boolean;
};

type RowProps = {
  isError?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  margin-bottom: 8px;
  border: ${({ isError }) => `solid 1px ${isError ? ColorPalette.HEX.RedRYB : ColorPalette.HEX.BrightGray}`};

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
    border: none;
  }
`;

export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: fit-content;
  border-radius: 12px;
  padding: 16px 24px;
  background-color: ${({ theme }) => theme.radioCard.background};
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    border: ${({ isError }) => `solid 1px ${isError ? ColorPalette.HEX.RedRYB : ColorPalette.HEX.BrightGray}`};
  }
`;

export const Body = styled.div`
  width: 100%;
  border-radius: 0 0 12px 12px;
  background-color: ${({ theme }) => theme.radioCard.border};

  @media ${({ theme }) => theme.device.desktop} {
    border-radius: 12px;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme }) => theme.radioCard.title};
`;

export const Subtitle = styled.div`
  margin: 8px 0;
  font-size: 12px;
  max-width: 90%;
  line-height: 1.5;
  color: ${({ theme }) => theme.radioCard.subtitle};
`;

export const RadioButtonContainer = styled.div`
  margin-left: auto;
`;
